define('ordersDetailOrderCommentsListView',[
  'module',
  'backbone',
  'underscore',
  'marionette',
  'ordersDetailOrderCommentsListCommentView',
  'ordersDetailOrderCommentsEditView',
  'settings',
  'commentsTags',
  'entities/common'
], function (
  Module,
  Backbone,
  _,
  Marionette,
  CommentView,
  EditView,
  Settings,
  Tags
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    childView: CommentView,
    className: 'list-view',

    childViewOptions: function() {
      return {
        order: this.model,
        pin: true
      };
    },

    childEvents: {
      'delete': 'onDelete',
      'removeTag': 'onRemoveTag',
      'pin': 'onPin'
    },  
    
    initialize: function() {
      this.collection = new Backbone.Collection();
      this.allCollection = new Backbone.Collection();      

      this.listenTo(this.model, 'change', _.bind(function(model) {
        if (model.hasChanged('comments'))
          this.fetch();
      }, this));

      if(Settings.configValue('advancedMode') === true) {
        this.options.tagsView.on('change', _.bind(function() {
          this.fetch();
        }, this));
      }
    },

    onShow: function() {      
      this.fetch();      
    },

    onRender: function() {
      if(Settings.configValue('advancedMode') === true) {
        var items = {};
        _.each(Tags.get(), function(tag) {
          if(tag.contextMenu) {
            items[tag.id] = {
              name: tag.name
            };
          }
        }, this);

        this.$el.contextMenu({
          selector: '.comment-view',
          className: 'comment-context-menu',
          build: _.bind(function () {
            return {
              callback: _.bind(function (tag, options) {
                var model = this.collection.get(options.$trigger.data('cid'));
                
                if(!tag)
                  return;
            
                var tags = [];
                var value = model.get('tags');
                if(value)
                  tags = value.split(',');
            
                if(tags.indexOf(tag) === -1)
                  tags.push(tag);   
            
                model.set('tags', tags.join(','));
              
                this.model.updateComment(model).done(_.bind(function() {
                  this.model.fetch();
                }, this));
              }, this),
              items: items
            };
          }, this)
        });
      }
    },

    fetch: function() {
      this.allCollection.set(this.model.get('comments'));

      var models = _.filter(this.allCollection.models, function(model) {
        if(model.get('type') && model.get('type') === 'order')
          return true;
        else
          return false;
      }, this);
     
      if(this.options.tagsView) {
        _.each(this.options.tagsView.tags, function(tag) {
          var visible = false;
          _.each(models, function(model) {
            if(model.get('tags') && model.get('tags').includes(tag.id)) 
              visible = true;               
          }, this);
          tag.visible = visible;
        }, this);
        
        this.options.tagsView.fetch();

        models = _.filter(models, function(model) {
          var selectedTag = this.options.tagsView.getSelected();
          if(selectedTag) {
            if(selectedTag.get('id')  === '') {
              var archived = model.get('tags') && model.get('tags').includes('archived');
              if(!archived)
                return true;
              else
                return false;
            }          
            
            if(model.get('tags') && model.get('tags').includes(selectedTag.get('id')))
              return true;

            return false;
          } else
            return true;
        }, this);
      }

      models = models.sort(function (a, b) {
        if(a.get('pin') && b.get('pin')) {
          return a.get('msgDate') < b.get('msgDate') ? 1 : -1;
        }

        if(a.get('pin') && !b.get('pin')) {
          return -1;
        }

        if(!a.get('pin') && b.get('pin')) {
          return 1;
        }

        if(!a.get('pin') && !b.get('pin')) {
          return a.get('msgDate') < b.get('msgDate') ? 1 : -1;
        }
      });      

      this.collection.reset(models);
      this.trigger('fetched');
    },   
    
    onDelete: function(view) {
      this.collection.remove(view.model);      
      
      this.model.deleteComment(view.model).done(_.bind(function() {
        this.model.fetch();
      }, this));
    },

    onPin: function(view) {
      view.model.set('pin', !view.model.get('pin'));
      this.model.updateComment(view.model).done(_.bind(function() {
        this.model.fetch();
      }, this));
    },

    onRemoveTag: function(view, key) {     
      if (this.options.removeTag)
        this.options.removeTag(view.model, key);
    }
  });
});
